import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import i18n from 'i18next';
import { message } from 'antd';
import CookieUtil from '@/utils/cookies';

// 创建 axios 实例
const request = axios.create({
  baseURL: '/api', // API 的基础URL
  timeout: 1000 * 120, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token');
    localStorage.setItem('storeEntryCurrentStep','0');
    if (token) {
      config.headers.token = `${token}`;
    }
    // 设置 Accept-Language 头，支持中英西日
    // const languageMap: { [key: string]: string } = {
    //   'zh-hans': 'zh-hans',
    //   'en': 'en',
    //   'es': 'es',
    //   'ja': 'ja',
    //   'fr': 'fr',
    //   'de': 'de',
    //   'ru': 'ru',
    //   'it': 'it'
    // };
    const languageMap: { [key: string]: string } = {
      'zh': 'zh-hans',
      'en': 'en',
      'es': 'es',
      'jp': 'ja',
      'fr': 'fr',
      'de': 'de',
      'ru': 'ru',
      'it': 'it'
    };
    //console.log("i18n.language === ",i18n.language);
    //console.log("languageMap[i18n.language] === ",languageMap[i18n.language]);
    config.headers['Accept-Language'] = languageMap[i18n.language] || 'en';
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    // 对响应数据做点什么
    const { data } = response;
    if (data.code === 200) {
      return data;
    } else if (data.code === 401) {
      message?.error(data.message || i18n.t('common.unauthorized'));
      window.location.href = '/login';
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
     
      CookieUtil.remove('token');
      CookieUtil.remove('userInfo');
    }
    message?.error(data.message || i18n.t('common.requestFailed'));
    return Promise.reject(new Error(data.message || i18n.t('common.requestFailed')));
  },
  (error) => {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，跳转到登录页
          message?.error(error?.response?.data?.msg || i18n.t('common.unauthorized'));
          localStorage.setItem('locationHref',String(window.location.pathname));
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          CookieUtil.remove('token');
          CookieUtil.remove('userInfo');
          setTimeout(() => {
            window.location.href = '/login';
          }, 500);
          break;
        case 403:
          message?.error(i18n.t('common.forbidden'));
          break;
        case 404:
          message?.error(i18n.t('common.notFound'));
          break;
        case 500:
          //debugger
          //console.log(error, 'message');
          message?.error(error?.response?.data?.message || i18n.t('common.serverError'));
          break;
        default:
          message?.error(i18n.t('common.networkError'));
      }
    } else {
      message?.error(i18n.t('common.networkConnectionError'));
    }
    return Promise.reject(error);
  }
);

// 封装 GET 请求
export const get = <T = any>(url: string, params?: any, config?: AxiosRequestConfig): Promise<T> => {
  return request.get(url, { params, ...config });
};

// 封装 POST 请求
export const post = <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> => {
  return request.post(url, data, config);
};

// 封装 PUT 请求
export const put = <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> => {
  return request.put(url, data, config);
};

// 封装 DELETE 请求
export const del = <T = any>(url: string, config?: AxiosRequestConfig): Promise<T> => {
  return request.delete(url, config);
};

export default request; 